// import fb from '../firebaseConfig'

export default store => {
  // if (!store.state.user) {
  //   return
  // }

  // const userId = store.state.user.uid

  // load data from firestore
  // @todo update to refresh local data
  // fb.db.collection('users').doc(userId).collection('shits').orderBy('createdAt').get({ source: 'cache' }).then(querySnapshot => {
  //   const shits = []
  //   let projects = []
  //   let contexts = []
  //   let mentions = []

  //   querySnapshot.forEach(d => {
  //     const shit = d.data()
  //     shits.push(shit)

  //     projects = projects.concat(shit.projects)
  //     contexts = contexts.concat(shit.contexts)
  //     mentions = mentions.concat(shit.mentions || [])
  //   })

  //   // remove duplicates
  //   projects = [...new Set(projects)]
  //   contexts = [...new Set(contexts)]
  //   mentions = [...new Set(mentions)]

  //   store.commit('hydrateShits', shits)
  //   store.commit('hydrateProjects', projects)
  //   store.commit('hydrateContexts', contexts)
  //   store.commit('hydrateMentions', mentions)
  //   store.commit('setLoaded')
  // })

  // subscribe to mutations
  // store.subscribe((mutation, state) => {
  //   if (mutation.type === 'admitShit') {
  //     const shit = mutation.payload
  //     const shitId = shit.uuid
  //     // @todo optimize
  //     fb.db.collection('users').doc(userId).collection('shits').doc(shitId).set(shit)
  //   } else if (mutation.type === 'deleteShit') {
  //     const shit = mutation.payload
  //     const shitId = shit.uuid
  //     fb.db.collection('users').doc(userId).collection('shits').doc(shitId).delete()
  //   }
  // })

  // subscribe to realtime updates from firestore
  // fb.db.collection('users').doc(userId).collection('shits').onSnapshot(querySnapshot => {
  //   if (querySnapshot.metadata.fromCache || querySnapshot.metadata.hasPendingWrites) {
  //     return
  //   }
  //   querySnapshot.docChanges().forEach(change => {
  //     const shit = change.doc.data()
  //     if (change.type === 'modified') {
  //       store.commit('hydrateShit', shit)
  //     } else if (change.type === 'added') {
  //       store.commit('downloadShit', shit)
  //     } else if (change.type === 'removed') {
  //       store.commit('dropShit', shit)
  //     }
  //   })
  // })
}
